"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconArrowRight = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const IconArrowRight = (props) => {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { ...props, width: "448", height: "512", viewBox: "0 0 448 512", fill: "none", children: (0, jsx_runtime_1.jsx)("path", { d: "M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z" }) }));
};
exports.IconArrowRight = IconArrowRight;
